import { useQuery } from '@tanstack/react-query';
import { regionApi } from '../api/region.api';
import { regionKeys } from '../api/region.keys';
import type { Region } from '@/shared/types';

export function useRegionDetails(id: string | number | undefined) {
  return useQuery<Region>({
    queryKey: regionKeys.detail(id!),
    queryFn: () => regionApi.getById(id!),
    enabled: !!id,
  });
}
